import React, { useEffect } from 'react';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@src/common/Button';
import { storage } from '@uhg-abyss/web/tools/storage';
import PropTypes from 'prop-types';
import { useUser } from '@src/state/user';
import { config } from '@uhg-abyss/web/tools/config';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { HAS_SIGNED_OUT } from './constants';
import { Countdown } from './Countdown';

let timeLeft;
let modelOpen;

export const UserBlockedModal = ({
  events,
  isOpen,
  closeModal,
  timeRemaining,
}) => {
  const { uuid } = useUser.state();
  const isSuperUser = storage.local.get(uuid);
  const handleSignout = () => {
    storage.local.set(HAS_SIGNED_OUT, true);
    if (config('US3671382_SUPER_USER') && isSuperUser) {
      storage.local.remove(uuid);
    }
    events.onSignout();
  };

  useEffect(() => {
    timeLeft = timeRemaining;
  }, [timeRemaining]);

  useEffect(() => {
    modelOpen = false;
  }, []);

  useEffect(() => {
    timeLeft = timeRemaining;
    modelOpen = isOpen;
  }, [isOpen]);

  const handleTimeout = () => {
    closeModal();
  };

  return (
    <Modal
      width={600}
      isOpen={modelOpen}
      onClose={closeModal}
      title="Too Many Failed Attempts"
      footer={
        <Modal.Section>
          <Layout.Group alignLayout="right">
            <Button variant="outline" onClick={handleSignout}>
              Sign Out
            </Button>
            <Button onClick={closeModal}>Continue Working</Button>
          </Layout.Group>
        </Modal.Section>
      }
    >
      <Modal.Section>
        <div>
          User locked out due to invalid attempts. Please try again in one hour.
        </div>
        <div>
          Time remaining:{' '}
          {<Countdown countdownMS={timeLeft} onComplete={handleTimeout} />}
        </div>
      </Modal.Section>
    </Modal>
  );
};

UserBlockedModal.propTypes = {
  timeRemaining: PropTypes.number,
  events: PropTypes.shape({
    onSignout: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

UserBlockedModal.defaultProps = {
  timeRemaining: 600000,
};
